<div class="card hs-main-panel" [hidden]="(isVisible$ | async) === false">
    <hs-panel-header name="language" [title]="'PANEL_HEADER.LANGUAGE' | translateHs">
    </hs-panel-header>
    <div class="card-body">
        <ul class="m-3 list-group m-auto w-75 py-md-2">
            <button *ngFor="let lang of available_languages" class="btn m-2 m-md-1 p-4 p-md-2"
                [ngClass]="isCurrentLang(lang.key) ? ' btn-primary' : ' btn-secondary'"
                (click)="setLanguage(lang.key)">{{lang.name}}</button><!-- TODO: Remove function call from template -->
        </ul>
    </div>
</div>